export default "__VITE_ASSET__4b021144__"